import { ColumnConfig } from "components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const API_KEY_ROLES_COLUMNS_STORAGE_KEY = "apiKeyRolesColumnsConfig";
export const FILTERS_ORDER_SETTINGS_KEY = "apiKeyRolesFiltersOrder";

export const initialSortOption = "name";
export const initialSortDirection = SearchQueryOrderDirection.Desc;

export enum API_KEY_ROLES_COLUMN_ID {
  NAME = "NAME",
  DESCRIPTION = "DESCRIPTION",
  GRANTED_AT = "GRANTED_AT",
  DROPDOWN = "DROPDOWN",
}

export const ROW_HEADER_ID = API_KEY_ROLES_COLUMN_ID.NAME;

const MAX_CELL_WIDTH = 600;

export const API_KEY_ROLES_COLUMN_CONFIG: ColumnConfig = {
  [API_KEY_ROLES_COLUMN_ID.NAME]: {
    title: "Name",
    minWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: false,
  },

  [API_KEY_ROLES_COLUMN_ID.DESCRIPTION]: {
    title: "Description",
    minWidth: 130,
    maxWidth: MAX_CELL_WIDTH,
    resizable: false,
    static: true,
  },

  [API_KEY_ROLES_COLUMN_ID.GRANTED_AT]: {
    title: "Granted at",
    minWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    static: true,
    resizable: false,
  },
};

export const API_KEY_ROLES_CUSTOM_END_COLUMN_CONFIG: ColumnConfig = {
  [API_KEY_ROLES_COLUMN_ID.DROPDOWN]: {
    title: "More actions",
    noHeader: true,
    static: true,
    maxWidth: 60,
    minWidth: 60,
    width: 60,
    sticky: true,
    resizable: false,
  },
};

export const SORT_CONFIG: Record<string, string> = {
  [API_KEY_ROLES_COLUMN_ID.NAME]: "name",
  [API_KEY_ROLES_COLUMN_ID.GRANTED_AT]: "grantedAt",
};

export const INITIAL_COLUMNS_VIEW_CONFIG = {
  visible: Object.keys(API_KEY_ROLES_COLUMN_CONFIG) as API_KEY_ROLES_COLUMN_ID[],
  hidden: [],
};